// extracted by mini-css-extract-plugin
export default {"header":"Success_header__sfV5e","finished":"Success_finished__ir4Zx"};